module.exports = __webpack_public_path__ + "img/FCHS_ER_2023-8.ba4b1cdd.jpg";